import React from 'react'
import PropTypes from 'prop-types'
import { Button, Text, Row } from 'shared/components'

import * as styles from './styles'

const SelectorComponent = ({ isFavorite, onClick }) => {
  return (
    <Row css={styles.wrapper}>
      <div>
        <Button
          css={isFavorite ? styles.wrapperButtonActive : styles.wrapperButton}
          onClick={onClick}
        >
          <Text bold black={isFavorite} size={11}>
            Favorite
          </Text>
        </Button>
      </div>
      <div>
        <Button
          css={isFavorite ? styles.wrapperButton : styles.wrapperButtonActive}
          onClick={onClick}
        >
          <Text bold black={!isFavorite} size={11}>
            All
          </Text>
        </Button>
      </div>
    </Row>
  )
}

SelectorComponent.propTypes = {
  isFavorite: PropTypes.bool,
  onClick: PropTypes.func,
}

export default SelectorComponent
